import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DISPLAY_LANG } from "../../config";
import { onlyLatinMessage } from "../../api/user/register-page";
import { getRegisterData, registerEmail } from "../../api/user/register-page";
import Loading from "../../components/loading";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import countryList from "country-list";
import "react-phone-input-2/lib/style.css";
import "../../stylesheets/user/register.css";

export default function RegisterPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [pageData, setPageData] = useState(null);
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");
  // const [passwordConfirmError, setPasswordConfirmError] = useState("");

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    phone_cc: "",
    email: "",
    organization: "",
    country: "",
    city: "",
    post_code: "",
    location: "",
    region: "",
    passwd: "",
    passwdConfirm: "",
  });

  useEffect(() => {
    const loadingData = async () => {
      try {
        const data = await getRegisterData();
        setPageData(data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    loadingData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    sessionStorage.setItem('registerFormData', JSON.stringify(formData));
  }, [formData])

  const countryOptions = countryList.getData().map((c) => ({
    value: c.code,
    label: c.name,
    flagUrl: `https://flagcdn.com/24x18/${c.code.toLowerCase()}.png`,
  }));

  const onChangeInput = (e) => {
    const nonLatinLetters = /[^\p{Script=Latin}\d\s~!@#$%^&*()_+=\-`[\]{}|\\:;"'<>,.?/]/u;

    if (nonLatinLetters.test(e.target.value)) {
      return alert(onlyLatinMessage[DISPLAY_LANG]);
    }

    const data = { ...formData, [e.target.name]: e.target.value };
    setFormData(data);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };

  const validateAll = () => {
    let newErrors = {};

    if (!formData.full_name.trim()) newErrors.full_name = true;
    if (!formData.phone.trim()) newErrors.phone = true;
    if (!formData.email.trim()) newErrors.email = true;
    if (!formData.country.trim()) newErrors.country = true;
    if (!formData.city.trim()) newErrors.city = true;
    if (!formData.post_code.trim()) newErrors.post_code = true;
    if (!formData.location.trim()) newErrors.location = true;
    if (!formData.organization.trim()) newErrors.organization = true;
    if (!formData.region.trim()) newErrors.region = true;
    if (!formData.phone_cc) newErrors.phone_cc = true;

    return Object.keys(newErrors).length === 0;
  };

  const getPasswordStrength = (password) => {
    if (!password) {
      return {
        score: 0,
        color: "transparent",
        gradient: "transparent",
      };
    }

    let score = 0;

    // Length պարտադիր պայման
    if (password.length >= 9 && password.length <= 16) score++;

    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score++;

    // Եթե length-ը սխալ է՝ միշտ կարմիր
    if (password.length < 9 || password.length > 16) {
      return {
        score,
        color: "#ef4444",
        gradient: "linear-gradient(90deg, #f87171, #ef4444)",
        error: "Password must be between 9 and 16 characters.",
      };
    }

    // Կարմիր
    if (score <= 2) {
      return {
        score,
        color: "#ef4444",
        gradient: "linear-gradient(90deg, #f87171, #ef4444)",
      };
    }

    // Դեղին
    if (score <= 4) {
      return {
        score,
        color: "#f59e0b",
        gradient: "linear-gradient(90deg, #fbbf24, #f59e0b)",
      };
    }

    // Կանաչ
    return {
      score,
      color: "#10b981",
      gradient: "linear-gradient(90deg, #34d399, #10b981)",
    };
  };
  
  const onSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateAll();
    if (!isValid) {
      alert(pageData.alert_message_error);
      return;
    }

    const numericPhone = formData.phone.replace(/\D/g, "");
    const phonePattern = /^[0-9]{6,14}$/;
    if (!phonePattern.test(numericPhone)) {
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    if (!formData.passwd || !passwordRegex.test(formData.passwd)) {
      const errorMsg = {
        en: "Minimum 8 characters, uppercase, lowercase, number and symbol required",
        ru: "Требуется минимум 8 символов, заглавная буква, строчная буква, цифра и спецсимвол",
        am: "Պահանջվում է նվազագույնը 8 նիշ, մեծատառ, փոքրատառ, թիվ և հատուկ նշան",
      };
      alert(errorMsg[DISPLAY_LANG] || errorMsg.en);
      return;
    }

    if (!formData.passwdConfirm || formData.passwd !== formData.passwdConfirm) {
      alert(pageData.alert_password_error);
      return false;
    }

    try {
      window.scrollTo(0, 0);
      setIsLoading(true);
      await registerEmail(formData.email);
      navigate('/user/register/email-submit');
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading || !pageData) return <Loading />;

  const strength = getPasswordStrength(formData.passwd);

  return (
    <div className="register_page wrapper">
      <div className="container">
        <div className="content">
          <h3 className="title">{pageData.title}</h3>
          <p className="subtitle">{pageData.subtitle}</p>
        </div>

        <div className="register_login">
          <Link to="/user/register" className="reg_log active">
            {pageData.register_btn_text_head}
          </Link>
          <Link to="/user/login" className="reg_log">
            {pageData.login_btn_text}
          </Link>
        </div>

        <form onSubmit={onSubmit}>
          <div className="form_group">
            <label>
              {pageData.full_name_label} <span>*</span>
            </label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group">
            <label>
              {pageData.phone_label} <span>*</span>
            </label>
            <PhoneInput
              preferredCountries={["am", "ru", "ge", "us", "fr"]}
              value={formData.phone_cc + formData.phone}
              onChange={(value, data) => {
                const localNumber = value.replace(data.dialCode, "");
                setFormData({
                  ...formData,
                  phone: localNumber,
                  phone_cc: data.dialCode,
                });
              }}
              inputStyle={{
                width: "100%",
                fontSize: "14px",
                padding: "19px 19px 19px 50px",
              }}
              buttonStyle={{ borderRadius: "6px 0 0 6px" }}
              inputProps={{ name: "phone", type: "tel" }}
            />
          </div>

          <div className="form_group">
            <label>
              {pageData.email_label} <span>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group">
            <label>{pageData.organization_label}</label>
            <input
              type="text"
              name="organization"
              value={formData.organization}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group half">
            <label>
              {pageData.country_label} <span>*</span>
            </label>
            <Select
              name="country"
              options={countryOptions}
              value={
                formData.country
                  ? countryOptions.find((c) => c.value === formData.country)
                  : null
              }
              onChange={(selectedOption) => {
                setFormData({
                  ...formData,
                  country: selectedOption.value,
                });
              }}
              placeholder={pageData.select_country}
              formatOptionLabel={(option) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <img
                    src={option.flagUrl}
                    alt={option.label}
                    style={{ width: "20px", height: "14px" }}
                  />
                  <span>{option.label}</span>
                </div>
              )}
              styles={{
                control: (provided) => ({
                  ...provided,
                  fontSize: "16px",
                  borderRadius: "6px",
                  paddingLeft: "0",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "15px",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  fontSize: "14px",
                }),
                indicatorSeparator: () => ({ display: "none" }),
                menu: (provided) => ({ ...provided, overflowX: "hidden" }),
                option: (provided, state) => ({
                  ...provided,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#000",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                }),
              }}
            />
          </div>

          <div className="form_group half">
            <label>
              {pageData.city_label} <span>*</span>
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group half">
            <label>
              {pageData.region_label} <span>*</span>
            </label>
            <input
              type="text"
              name="region"
              value={formData.region}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group half">
            <label>
              {pageData.post_code_label} <span>*</span>
            </label>
            <input
              type="text"
              name="post_code"
              value={formData.post_code}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group">
            <label>
              {pageData.location_label} <span>*</span>
            </label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={onChangeInput}
            />
          </div>

          <div className="form_group">
            <label htmlFor="password">
              {pageData.password_label} <span>*</span>
            </label>
            <div className="input_with_icon">
              <input
                type={showPassword ? "text" : "password"}
                name="passwd"
                value={formData.passwd}
                onChange={handlePasswordChange}
                placeholder={''}
                className="new"
              />
              <span
                className="toggle_pass"
                onClick={() => setShowPassword(!showPassword)}
              >
                <img
                  src={
                    showPassword
                      ? "/images/users/eye-regular-full.svg"
                      : "/images/users/eye-slash-regular-full.svg"
                  }
                  alt="toggle password"
                />
              </span>
            </div>
            {formData.passwd && (
              <div className="password-strength-container" style={{ marginTop: "10px", width: "100%" }}>
                <div style={{
                  height: "6px",
                  width: "100%",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "10px",
                  overflow: "hidden"
                }}>
                  <div style={{
                    height: "100%",
                    width: `${(strength.score / 5) * 100}%`,
                    background: strength.gradient,
                    borderRadius: "10px",
                    transition: "width 0.3s ease, background 0.3s ease-in-out"
                  }} />
                </div>
              </div>
            )}
            <p className="pass-requirement">{pageData.password_placeholder}</p>
          </div>

          <div className="form_group">
            <label htmlFor="passwdConfirm">
              {pageData.confirm_password_label} <span>*</span>
            </label>
            <div className="input_with_icon">
              <input
                type={showPassword ? "text" : "password"}
                name="passwdConfirm"
                value={formData.passwdConfirm}
                onChange={(e) =>
                  setFormData({ ...formData, passwdConfirm: e.target.value })
                }
              />
              <span
                className="toggle_pass"
                onClick={() => setShowPassword(!showPassword)}
              >
                <img
                  src={
                    showPassword
                      ? "/images/users/eye-regular-full.svg"
                      : "/images/users/eye-slash-regular-full.svg"
                  }
                  alt="toggle password"
                />
              </span>
            </div>
          </div>

          <button type="submit" className="btn">
            {pageData.register_btn_text}
          </button>
        </form>

        <div className="social_register">
          <h3>{pageData.other_method_out_field}</h3>
          <div className="line"></div>
          <div className="socials">
            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-facebook.svg" alt="social icon" />
              </Link>
            </div>

            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-google.svg" alt="social icon" />
              </Link>
            </div>

            <div className="btn soc_icon">
              <Link to="/">
                <img src="/images/users/icon-apple.svg" alt="social icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
